import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'byte'
})
export class BytePipe implements PipeTransform {

  // Convert to size (MB) of file
  transform(size: number): string {
    if (Number((size / (1024 * 1024)).toFixed(2)) < 0.01) {
      return 0.01 + ' MB';
    } else {
      return (size / (1024 * 1024)).toFixed(2) + ' MB';
    }
  }
}
